import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import SplashScreen from './components/SplashScreen';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import DiscordRedirect from './pages/DiscordRedirect';
import FAQsPage from './pages/FAQsPage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Notification from './components/Notification';
import Footer from './components/Footer';

const AppContent: React.FC = () => {
  return (
    <NotificationProvider>
      <LanguageProvider>
        <div className="app">
          <ScrollToTop />
          <Navbar />
          <Notification />
          <main className="main">
            <Routes>
              <Route path="/about" element={<AboutPage />} />
              <Route path="/faqs" element={<FAQsPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/discord" element={<DiscordRedirect />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/" element={<HomePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </NotificationProvider>
  );
};


function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      document.documentElement.style.setProperty('--mouse-x', `${x}%`);
      document.documentElement.style.setProperty('--mouse-y', `${y}%`);

      document.body.style.setProperty('--grid-hover-opacity', '1');
    };

    const handleMouseLeave = () => {
      document.body.style.setProperty('--grid-hover-opacity', '0');
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
}

export default App;